// removed by extract-text-webpack-plugin
module.exports = {"linkContainer":"Login--linkContainer--VKsYv4I9","codeLinkContainer":"Login--codeLinkContainer--ZWDBYgvv","forgotLink":"Login--forgotLink--1OsmNIPQ","emailDisplay":"Login--emailDisplay--Qm3jJGl6","enterCodeLabel":"Login--enterCodeLabel--2R9vcbnm","codeExpiry":"Login--codeExpiry--12hMVBNI","resendDisabled":"Login--resendDisabled--3itxcqte","buttonContainer":"Login--buttonContainer--1mfYfm4X","fixedMessage":"Login--fixedMessage--HksWVwmu","submitButton":"Login--submitButton--376_q1If"};


//////////////////
// WEBPACK FOOTER
// ./src/App/auth/Views/Login.css
// module id = 1311
// module chunks = 2